var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"is-btn",on:{"click":_vm.goWx}},[_vm._v("立即观看")])])}
var staticRenderFns = []

export { render, staticRenderFns }